import type { FaireProductEntity } from "../../entity_types/product";

export const p_6o1fhgkjvo: FaireProductEntity = {
  token: "p_6o1fhgkjvo",
  type: "product",
  name: "Bride-to-Be Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/92bc394d078776034f814d42db76fb411516ea1f24dbe2d06a4fdddcd0ce7a0a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5209250a664e42c2b70e3f98028b739632f2ef2ab989885e5abe76dbf9f767f.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:37.196Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
